import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import VerifyEmailPage from './pages/VerifyEmailPage';
import ChangePasswordPage from './pages/ChangePasswordPage';
import DashboardPage from './pages/DashboardPage';
import PacientesPage from './pages/PacientesPage';
import BuscarAnalisisPage from './pages/BuscarAnalisisPage';
import NuevoAnalisisPage from './pages/NuevoAnalisisPage';
import EstudiosPage from './pages/EstudiosPage';
import LaboratoriosPage from './pages/LaboratoriosPage';
import ObrasSocialesPage from './pages/ObrasSocialesPage';
import MisResultadosPage from './pages/MisResultadosPage';
import MiCuentaPage from './pages/MiCuentaPage';
import LandingPage from './pages/LandingPage';
import { homeForRole } from './utils/roleHome';

const STAFF_ROLES = ['ADMIN', 'ANALYST'];

function RootRedirect() {
  const { isAuthenticated, user } = useAuth();
  if (isAuthenticated) return <Navigate to={homeForRole(user?.role)} replace />;
  return <LandingPage />;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<RootRedirect />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/verify-email" element={<VerifyEmailPage />} />
      {/* No se envuelve en ProtectedRoute: debe admitir el flujo de contraseña
          expirada, que llega sin sesión activa. La protección normal se aplica
          dentro del propio componente. */}
      <Route path="/change-password" element={<ChangePasswordPage />} />
      <Route
        path="/mi-cuenta"
        element={
          <ProtectedRoute allowedRoles={[...STAFF_ROLES, 'VIEWER']}>
            <MiCuentaPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/mis-resultados"
        element={
          <ProtectedRoute allowedRoles={['VIEWER']}>
            <MisResultadosPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute allowedRoles={STAFF_ROLES}>
            <DashboardPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/pacientes"
        element={
          <ProtectedRoute allowedRoles={STAFF_ROLES}>
            <PacientesPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/nuevo-analisis"
        element={
          <ProtectedRoute allowedRoles={STAFF_ROLES}>
            <NuevoAnalisisPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/buscar-analisis"
        element={
          <ProtectedRoute allowedRoles={[...STAFF_ROLES, 'MEDICO']}>
            <BuscarAnalisisPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/analisis/:id/editar"
        element={
          <ProtectedRoute allowedRoles={STAFF_ROLES}>
            <NuevoAnalisisPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/estudios"
        element={
          <ProtectedRoute allowedRoles={STAFF_ROLES}>
            <EstudiosPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/laboratorios"
        element={
          <ProtectedRoute allowedRoles={STAFF_ROLES}>
            <LaboratoriosPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/obras-sociales"
        element={
          <ProtectedRoute allowedRoles={STAFF_ROLES}>
            <ObrasSocialesPage />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
